// extracted by mini-css-extract-plugin
export default {"root":"pBnFBilAkh","mainMenu":"NCZBeeZ_ds","header":"kmgyqOzkyu","events":"u8uJ82ezlb"};